import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	ButtonDropdown,
	DropdownToggle,
	DropdownItem,
	DropdownMenu,
} from "reactstrap";
import "./style.scss";

export const statusMenuConfig = [
	{ label: "All members", value: "all", color: "transparent", permissionKey: "all" },
	{ label: "Clocked in", value: "clocked-in", color: "#5428e0", permissionKey: "clockedIn" },
	{ label: "Clocked out", value: "clocked-out", color: "red", permissionKey: "clockedOut" },
	{ label: "On break", value: "on-break", color: "#F99B16", permissionKey: "onBreak" },
	{ label: "Not active", value: "not-active", color: "#6B7280", permissionKey: "notActive" },
	{ label: "Time off", value: "time-off", color: "#FB7185", permissionKey: "timeOff" },
];

const config = statusMenuConfig;

function Menu({ setStatus, setPage, setSelectedUsers, allowedStatuses }) {
	const items = allowedStatuses
		? config.filter((item) => allowedStatuses.includes(item.value))
		: config;
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	const onItemClick = useCallback(
		(value) => {
			setStatus(value);
			setIsOpen(false);
			setPage(0);
		},
		[setStatus, setIsOpen, setPage],
	);

	return (
		<ButtonDropdown
			isOpen={isOpen}
			toggle={() => {
				setIsOpen(!isOpen);
			}}
			direction="right"
		>
			<DropdownToggle className="shadow-none border-0 bg-transparent p-2">
				<i
					className="fa-solid fa-clock text-muted"
					style={{
						fontSize: "14px"
					}}
				/>
			</DropdownToggle>

			<DropdownMenu>
				{items.map(({ label, value, color }) => (
					<DropdownItem
						key={value}
						onClick={() => {
							onItemClick(value);
							setSelectedUsers([]);
						}}
						className="item"
					>
						<i
							className="fa-solid fa-check text-white icon"
							style={{
								backgroundColor: color,
							}}
						/>

						{t(label)}
					</DropdownItem>
				))}
			</DropdownMenu>
		</ButtonDropdown>
	);
}

export default Menu;
